
/** DO NOT EDIT THIS FILE! */
import { Version } from '@angular/core';
import { Bundle } from './models';

export const VERSION = new Version('2.0.62');

export const BUNDLE: Bundle = {
  date: 1793788393457,
  commitSha: 'unknown',
  version: VERSION,
};
